import { useCallback } from "react";
import { EventTypes } from "./eventTypes";
import { getAnalytics } from "./analyticsInstance";

export function useAnalytics() {
  const analytics = getAnalytics();

  const trackEvent = useCallback((eventName: string, properties?: Record<string, any>) => {
    analytics.trackEvent(eventName, {
      path: window.location.pathname,
      title: document.title,
      ...properties,
    });
  }, [analytics]);

  const trackPageView = useCallback((page: string, properties?: Record<string, any>) => {
    trackEvent(EventTypes.PAGE_VIEW, {
      page,
      ...properties,
    });
  }, [analytics]);

  const trackButtonClick = useCallback((buttonName: string, properties?: Record<string, any>) => {
    trackEvent(EventTypes.BUTTON_CLICK, {
      button_name: buttonName,
      ...properties,
    });
  }, [analytics]);

  const trackFormSubmit = useCallback((formName: string, success: boolean, properties?: Record<string, any>) => {
    trackEvent(EventTypes.FORM_SUBMIT, {
      form_name: formName,
      success,
      ...properties,
    });
  }, [analytics]);

  const trackSearch = useCallback((query: string, resultsCount?: number, properties?: Record<string, any>) => {
    trackEvent(EventTypes.SEARCH, {
      query,
      results_count: resultsCount,
      ...properties,
    });
  }, [analytics]);

  const identify = useCallback((userId: string, properties?: Record<string, any>) => {
    analytics.identify(userId, properties);
  }, [analytics]);

  const reset = useCallback(() => {
    analytics.reset();
  }, [analytics]);

  return {
    trackEvent,
    trackPageView,
    trackButtonClick,
    trackFormSubmit,
    trackSearch,
    identify,
    reset,
  };
}
